// app/frontend/composables/useBreakpoint.js
import { ref, computed, onMounted, onUnmounted } from 'vue'

export const BP = { sm: 640, md: 768, lg: 1024, xl: 1280 }

const width = ref(typeof window !== 'undefined' ? window.innerWidth : 1280)
const pointer = ref(
  typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches ? 'coarse' : 'fine'
)

let listeners = 0
const onResize = () => { width.value = window.innerWidth }

export function useBreakpoint() {
  onMounted(() => {
    if (listeners++ === 0 && typeof window !== 'undefined') {
      window.addEventListener('resize', onResize, { passive: true })
    }
  })
  onUnmounted(() => {
    if (--listeners === 0 && typeof window !== 'undefined') {
      window.removeEventListener('resize', onResize)
    }
  })
  return {
    width,
    pointer,
    isMobile:  computed(() => width.value < BP.md),
    isTablet:  computed(() => width.value >= BP.md && width.value < BP.lg),
    isDesktop: computed(() => width.value >= BP.lg),
    atLeast:   (bp) => computed(() => width.value >= BP[bp]),
    BP,
  }
}
